import React from 'react';

class Placeholder extends React.Component {
    render () {
        return (
            <div className="placeholder">
                <p>{this.props.message}</p>
            </div>
        )
    }
}

export default Placeholder;